'use client'

import { useSyncExternalStore } from 'react'

export function useMediaQuery(query: string, defaultValue = false): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(query)
      mql.addEventListener('change', onChange)
      return () => mql.removeEventListener('change', onChange)
    },
    () => window.matchMedia(query).matches,
    () => defaultValue,
  )
}

export const BREAKPOINTS = {
  narrow: 1024,
  wide: 1280,
  ultraWide: 1920,
} as const

export const BREAKPOINT_QUERIES = {
  isNarrow: `(max-width: ${BREAKPOINTS.narrow - 1}px)`,
  isCompact: `(min-width: ${BREAKPOINTS.narrow}px) and (max-width: ${BREAKPOINTS.wide - 1}px)`,
  isBelowWide: `(max-width: ${BREAKPOINTS.wide - 1}px)`,
  isUltraWide: `(min-width: ${BREAKPOINTS.ultraWide}px)`,
} as const
